<template>
  <div id="app">
    <head-Back title="买一送一"></head-Back>
    <div class="page">
      <div class="page-head"></div>
      <div class="page-head-p">选择其中一个好友，享受同等VIP特权</div>
      <div class="page-content">
        <ul v-show="ffalg" >
          <li class="page-user" v-for="item in friends"  @click="checkUser(item)">

            <div class="page-user-check">
              <img class v-show="friend.friendUid == item.friendUid"  src="./img/check.png" alt />
              <img class v-show="friend.friendUid != item.friendUid"  src="./img/uncheck.png" alt />
            </div>
            <div class="page-user-logo">
              <img v-if=" item.portrait != '' "
                :src="item.portrait"
                alt
              />

               <img v-if=" item.portrait == '' "
                src="./img/default.jpg"
                alt
              />
            </div>
            <div class="page-user-centent">
              <span class="page-user-name"   v-show="item.alias == ''" >{{item.displayName}}</span>
              <span class="page-user-name" v-show="item.alias != ''" >{{item.alias}}</span>
            </div>

          </li>
        </ul>
        <div class="nofriend" v-show="!ffalg">
            <p>您暂无好友
             <br />
             <br />   
             <span>购买VIP后，保留赠送特权<br />联系客服即可使用</span>
            </p>
        </div>
      </div>
      <div class="page-button" @click="addOneByOne()" >立即购买VIP</div>
      <div class="page-desc">
        <span> 活动规则</span>
        <br /> <span>1.活动期间购买vip，即可选择其中一个好友，享受同等VIP特权；</span>
        <br /> <span>2.单次购买时，所选择享受同等优惠的好友只能选择一次，不可更改；</span>
        <br /> <span>3.VIP特权不退不换；</span>
        <br /> <span>4.该活动的最终解释权归本应用所有。</span>
        <br />
      </div>
    </div>
  </div>
</template>
<script>
import headBack from "../common/head-back";

//接口地址
import api from "../../api/index";
//toast组件
import tips from "@/estoast";
import util from "@/utils/util";
import store from "@/store";
import * as types from "../../store/types";
import { mapGetters } from "vuex";


export default {
  metaInfo: {
    title: "买一送一"
  },
  name: "app",
  data() {
    return {
      msg: "活动页面",
      friends: [],
      uid:'',
      friend:null,
      touid:'',
      ffalg:true,
    };
  },
  mounted(){
    
    var uid = this.$route.params.uid;
    console.log("uid:" + uid);
    this.uid = uid;
    this.getUserFriend();
  },
  methods: {

    checkUser(a){
      console.log(JSON.stringify(a))
      this.friend = a;
      this.touid = a.friendUid;
    },
    getUserFriend(){
      
      var params= {
        "uid":this.uid
      }

      
      this.$axiosHttp({
        method: "POST",
        url: api.qml.getUserFriend,
        data: params
      })
        .then(res => {
          console.log(res);
          if (res.code == 0) {
            this.friends =res.result;
            this.friend = res.result[0];
            this.touid =  res.result[0].friendUid;
            console.log(JSON.stringify(this.friendUid));
            if( res.result.length > 0){
              this.ffalg = true;
            }
          } else {
            tips.toast(res.message);
          }

        });

    },
    addOneByOne(){
       
      if(this.friends.length > 0){
          
      }else{
         //跳转到支付页面
          // this.$router.push("/pay");
           this.$router.push({
              name: "pay",
              params: {"showo":0}
            });
          return
      }
       
      var params = {
        "uid":this.uid,
        "touid":this.touid
      };
      console.log("请求的参数："+JSON.stringify(params));

      this.$axiosHttp({
        method: "POST",
        url: api.qml.addOneByOne,
        data: params
      })
        .then(res => {
          console.log(res);
          if (res.code == 0) {
              //跳转到支付页面
              // this.$router.push("/pay");
            this.$router.push({
                name: "pay",
                params: {"showo":0}
              });

          } else {
            tips.toast(res.message);
          }

        });



    }




  },
  components: {
    headBack
  },
   computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList",
      "getSToken"
    ])
  },
};
</script>
<style  scoped>
.page {
  width: 750px;
  height: 1344px;
}
.page-head {
  background: url("./img/banner-vip.png");
  background-size: 100% 100%;
  height: 100px;
  width: 686px;
  margin: 32px auto 0px;
}
.page-head-p {
  font-family: PingFangSC-Semibold;
  font-size: 28px;
  color: #181723;
  letter-spacing: -0.07px;
  margin: 24px auto 0px;
  font-weight: 600;
}
.page-content {
  background: #ffffff;
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  border-radius: 5px;
  width: 686px;
  height: 600px;
  margin: 20px auto 20px;
  overflow-y: scroll;
}
ul {
  padding: 0px;
  margin: 0px;
}
.page-user {
  list-style: none;
  padding: 0px;
  margin: 0px;
  display: flex;
}
.page-user-check {
  width: 44px;
  height: 44px;
  border: 0 solid #cfcfcf;
  flex: none;
  margin: 44px 32px;
}

.page-user-check img {
  width: 100%;
  height: 100%;
}

.page-user-logo {
  border-radius: 2px;
  border-radius: 2px;
  width: 88px;
  height: 88px;
  flex: none;
  margin: 22px 24px 0 22px;
}
.page-user-centent {
  border-radius: 2px;
  border-radius: 2px;
  height: 88px;
  flex: 1;
  margin: 44px 0 0 0;
  text-align: left;
}

.page-user-name {
  font-family: PingFangSC-Medium;
  font-size: 28px;
  color: #333333;
  font-weight: 600;
}
.page-user-remark {
  font-family: PingFangSC-Regular;
  font-size: 26px;
  color: #999999;
}

.page-user-check img,
.page-user-logo img,
.page-user-centent img {
  width: 100%;
  height: 100%;
}
.page-button {
  background-image: linear-gradient(180deg, #2d50ed 0%, #4ea0fe 100%);
  box-shadow: 0 2px 6px 2px #cadeff;
  border-radius: 25px;
  border-radius: 25px;
  width: 632px;
  height: 92px;
  margin: 32px auto 32px;
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #ffffff;
  letter-spacing: -0.08px;
  text-align: center;
  line-height: 92px;
}
.page-desc {
  font-family: PingFangSC-Regular;
  font-size: 24px;
  color: #999999;
  width: 686px;
  height: 204px;
  margin: 0 auto;
  text-align: left;
}

.page-desc span{
  line-height: 33px;
}
.nofriend{
  width: 100%;
  height: 100%;
}
.nofriend p {
  margin-top: 180px ;
}

</style>


// WEBPACK FOOTER //
// src/components/active/buyonebyone.vue